import * as universal from '../entries/pages/_layout.js';

export const index = 0;
export const component = async () => (await import('../entries/fallbacks/layout.svelte.js')).default;
export const file = '_app/immutable/components/layout.svelte-41fa68e6.js';
export { universal };
export const imports = ["_app/immutable/components/layout.svelte-41fa68e6.js","_app/immutable/chunks/index-ae03fd13.js","_app/immutable/modules/pages/_layout.js-58d5d7a5.js","_app/immutable/chunks/_layout-12c03cb0.js"];
export const stylesheets = [];
export const fonts = [];
